import React, { useEffect, useState } from 'react';
import { HomeHero } from '../components/home/HomeHero.tsx';
import { WhyChooseSFrays } from '../components/home/WhyChooseSFrays.tsx';
import { OurExpertise } from '../components/home/OurExpertise.tsx';
import { ImpactNumbers } from '../components/home/ImpactNumbers.tsx';
import { HomeCTA } from '../components/home/HomeCTA.tsx';
import {Footer} from '../components/contact/Footer.tsx';

export function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`home-page ${isLoaded ? 'loaded' : ''}`} style={{ paddingTop: '80px' }}>
      <HomeHero />
      <WhyChooseSFrays />
      <OurExpertise />
      <ImpactNumbers />
      <HomeCTA />
      <Footer />
    </div>
  );
}
